import { gql } from '@apollo/client';

const FRAUD_CHECK = gql`
  mutation FraudCheck($msisdn: String!, $click_id: String, $advertiser_id:String,$source_ip: String, $user_agent: String) {
    fraudCheck(msisdn: $msisdn, click_id: $click_id,advertiser_id:$advertiser_id,source_ip: $source_ip, user_agent: $user_agent) {
      msisdn
      click_id
      advertiser_id
      cg_url
      mf_id
    }
  }
`;

export default FRAUD_CHECK;